import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                {appData.desc}
              </p>
              <ul className="space-y-2 mb-6">
                {appData.features.map((feat) => (
                  <li key={feat} className="flex items-center gap-2 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-primary-600 text-xs"></i>
                    </span>
                    {feat}
                  </li>
                ))}
              </ul>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 font-medium rounded-lg hover:bg-foreground-800 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 font-medium rounded-lg hover:bg-foreground-800 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4 flex-shrink-0">
              <div className="hidden sm:block">
                <img
                  src={appData.appImage}
                  alt="吃瓜51 APP界面"
                  className="w-[180px] md:w-[220px] h-auto rounded-2xl"
                  width="600"
                  height="800"
                />
              </div>
              <div className="bg-background-50 rounded-xl p-3 border border-background-200/70">
                <img
                  src={appData.qrImage}
                  alt="吃瓜51 APP下载二维码"
                  className="w-[120px] h-[120px] rounded-lg"
                  width="300"
                  height="300"
                />
                <p className="text-xs text-foreground-400 text-center mt-2">扫码下载</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}